import { useCardBalance } from '@shared/hooks';
import { AmountUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface ICardBalanceProps {
  id: number;
}

export const CardBalance = (props: ICardBalanceProps) => {
  const balance = useCardBalance(props.id);

  return (
    <Text className='text-nowrap' size='sm'>
      {typeof balance === 'number' ? AmountUtils.transformToAmountWithCurrency(balance) : ''}
    </Text>
  );
};
